<template>
<div class="chapter">
<div class="inner_page">
<p style="text-align:center"><img alt="logo" src="images/logo.jpg"/></p>
<p class="indent"> </p>
<p class="indent"> </p>
<p class="blurb">This edition of <em>The Physiology of Taste</em> by Jean A. Brillat-Savarin  was reproduced by permission from the volume in the collection of the American Antiquarian Society (AAS), Worcester, Massachusetts. Founded in 1812 by Isaiah Thomas, a Revolutionary War patriot and successful printer and publisher, the Society is a research library documenting the life of Americans from the colonial era through 1876. AAS aims to collect, preserve, and make available as complete a record as possible of the printed materials from the early American experience. The cookbook collection includes approximately 1,100 volumes.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// blurb.vue?ea1c60be